import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-port-component',
  templateUrl: './port-component.component.html',
  styleUrls: ['./port-component.component.scss']
})
export class PortComponentComponent implements OnInit {

  @Input() routes;
  // @Input() requestDetails;
  @Input() addresses;
  constructor() { }

  ngOnInit(): void {
  }

}
